import React from 'react';
import { Icon } from '@blueprintjs/core';
import { useSelector, useDispatch } from 'react-redux';
import { reopenUpdateDialog } from '../update/update-actions';
import { getTheme, THEME_CHANGED_COMMAND } from './theme';

const StatusBar = (props) => {
    const dispatch = useDispatch();
    const { state: updateState, progressPercent } = useSelector((s) => s.update);
    const [theme, setTheme] = React.useState(() => getTheme());

    const fireToggleSection = (sectionName) => {
        window['bodapro-context'].triggerCommand('toggle-layout-section', { sectionName });
    };

    const openBip = () => {
        window['bodapro-context']
            .executeCommand('bodapro.bip.open', { contextKey: props?.params?.bipContextKey })
            .catch(() => {}); // launcher already shows a toast on failure
    };

    const [appVersion, setAppVersion] = React.useState(
        () => window.bodapro?.BodaProRunConfig?.appVersion || null
    );

    React.useEffect(() => {
        if (appVersion) return;
        window.bodapro?.getRunConfig?.().then(cfg => {
            setAppVersion(cfg?.appVersion || null);
        });
    }, []);

    React.useEffect(() => {
        setTheme(getTheme());
        const ctx = window['bodapro-context'];
        if (!ctx?.subscribeToCommand) return undefined;
        const sub = ctx.subscribeToCommand(THEME_CHANGED_COMMAND, ({ theme: next }) => {
            if (next === 'light' || next === 'dark') {
                setTheme(next);
            }
        });
        return () => sub?.unsubscribe?.();
    }, []);

    const toggleTheme = () => {
        const next = theme === 'dark' ? 'light' : 'dark';
        window['bodapro-context']?.setTheme?.(next);
        setTheme(next);
    };

    const version = appVersion || '...';

    return (<div style={{display: 'flex', padding: 5}}>
        <div style={{display: 'flex', alignItems: 'center', gap: 10}}>
            <Icon icon="layout-right-column-two-tiles" onClick={() => fireToggleSection('primary-sidebar')} style={{cursor: 'pointer'}} />
            <Icon icon="layout-left-column-two-tiles" onClick={() => fireToggleSection('secondary-sidebar')} style={{cursor: 'pointer'}} />
            <Icon icon="layout-top-row-two-tiles" onClick={() => fireToggleSection('bottom-panel')} style={{cursor: 'pointer'}} />
        </div>
        <div style={{flex: 1}}></div>
        <div style={{display: 'flex', alignItems: 'center', gap: 10}}>
            <Icon
                icon="clean"
                title="Boda Intelligent Prompt"
                onClick={openBip}
                style={{cursor: 'pointer'}}
            />
            {(updateState === 'available' || updateState === 'downloaded') && (
                <Icon
                    icon="cloud-download"
                    intent="warning"
                    title={updateState === 'downloaded' ? 'Update downloaded — click to restart & install' : 'Update available — click to view'}
                    onClick={() => dispatch(reopenUpdateDialog())}
                    style={{cursor: 'pointer'}}
                />
            )}
            {updateState === 'downloading' && (
                <div title="Downloading update">{progressPercent || 0}%</div>
            )}
            <Icon
                icon={theme === 'dark' ? 'flash' : 'moon'}
                title={theme === 'dark' ? 'Switch to light mode' : 'Switch to dark mode'}
                onClick={toggleTheme}
                style={{cursor: 'pointer'}}
            />
            <div>v{version}</div>
        </div>
    </div>);
}

export default StatusBar;
